import React from 'react';
import styles from './OpponentCards.module.css';
// import GameCard from '../GameCard/GameCard';
import { GameCard } from '@themed-components';
import { M_CARD, OPPONENT_CARDS, S_CARD, TEXAS_HOLDEM } from '@/Poker/data/Constants';
import { useGameDefinition } from '@/src/hooks/data/useGameTable';

export default function OpponentCards({ cards, revealCard, playerSeat, position, clientChairIndex, tempTableId }) {
    const gameDefinition = useGameDefinition(tempTableId);
    const { gameType, maxPlayers } = gameDefinition || {};

    const returnCardSize = () => {
        switch (gameType) {
            case TEXAS_HOLDEM:
                return M_CARD;
            default:
                return M_CARD;
        }
    }

    const returnCardLeftPosition = (index) => {
        switch (gameType) {
            case TEXAS_HOLDEM:
                return { marginLeft: `${index * -25}%` };
            default:
                return { marginLeft: index === 0 ? 0 : -22 };
        }
    }

    const getPositionClass = () => {
        // Generic logic for other player counts
        const halfPoint = Math.floor(maxPlayers / 2);
        if (clientChairIndex === 0) return styles.bottom;
        if (clientChairIndex < halfPoint) return styles.left;
        if (clientChairIndex === halfPoint) return styles.top;
        return styles.right;
    };

    return revealCard && playerSeat !== position ? (
        <div className={`${styles.opponentCardsContainer} ${getPositionClass()}`}>
            {
                cards.map((card, index) => (
                    <GameCard
                        index={index}
                        type={OPPONENT_CARDS}
                        gameType={gameType}
                        tempTableId={tempTableId}
                        style={returnCardLeftPosition(index)}
                        size={returnCardSize()}
                        value={card} key={`opponentCard-${index}-${card}`} />
                ))
            }
        </div>
    ) : null;
}
